// 後門工具頁：meta.backdoorTitle / backdoorDescription 會顯示在後門首頁的工具清單
const backdoorRouteArr = [
  {
    path: '/backdoor/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'backdoorHome',
        component: () => import('@/views/Backdoor/BackdoorHome.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'mockBaNotification',
        name: 'backdoorMockBaNotification',
        component: () => import('@/views/Backdoor/BackdoorView.vue'),
        meta: {
          prev: 'backdoorHome',
          backdoorTitle: 'BA 告警模擬',
          backdoorDescription: '透過 dev / staging 告警後端觸發或結案公區告警事件'
        }
      },
      {
        // 出單機明細單測試：預覽並以正式列印流程測試各版明細單模板
        path: 'eposReceipt',
        name: 'backdoorEposReceipt',
        component: () => import('@/views/Backdoor/BackdoorEposReceipt.vue'),
        meta: {
          prev: 'backdoorHome',
          backdoorTitle: '出單機明細單測試',
          backdoorDescription: '預覽並以正式列印流程測試各版明細單模板'
        }
      },
      {
        // 音效通知測試：本地模擬推播，測試告警鈴聲與點餐通知音效的播放規則
        path: 'mockSound',
        name: 'backdoorMockSound',
        component: () => import('@/views/Backdoor/BackdoorMockSound.vue'),
        meta: {
          prev: 'backdoorHome',
          backdoorTitle: '音效通知測試',
          backdoorDescription: '本地模擬私區告警與點餐推播，測試告警鈴聲與點餐通知音效的播放規則'
        }
      }
    ]
  }
]

export default process.env.VUE_APP_ENV === 'prod' ? [] : backdoorRouteArr
